var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsOptional, IsString, Matches, MaxLength, ValidateNested, } from 'class-validator';
// An ISO 8601 date-time with an offset, or '' for no limit.
const DATE_TIME = /^$|^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/;
/**
 * One image of a hero, banner or popup list. Which optional fields a site uses
 * is in D2C_SITE_CONTENT_LISTS; an empty string means the site leaves it out.
 * `image` and `mobileImage` are a URL in the site image bucket or a path of a
 * file the site already serves (`/assets/...`); the server checks which.
 */
export class D2CSiteImageItem {
}
__decorate([
    IsString(),
    MaxLength(40),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "id", void 0);
__decorate([
    IsString(),
    MaxLength(500),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "image", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(500),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "mobileImage", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "alt", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "eyebrow", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "title", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "titleLine2", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(120),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "subtitle", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], D2CSiteImageItem.prototype, "brightPhoto", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(500),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "link", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(10),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "lang", void 0);
__decorate([
    IsOptional(),
    Matches(DATE_TIME, { message: '시작 시각 형식이 올바르지 않습니다.' }),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "startAt", void 0);
__decorate([
    IsOptional(),
    Matches(DATE_TIME, { message: '끝 시각 형식이 올바르지 않습니다.' }),
    __metadata("design:type", String)
], D2CSiteImageItem.prototype, "endAt", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], D2CSiteImageItem.prototype, "visible", void 0);
/** A hero, banner or popup list (`home.hero`, `home.banners`, `home.popup`). */
export class D2CSiteImageList {
}
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageList.prototype, "sectionTitle", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageList.prototype, "headline", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(60),
    __metadata("design:type", String)
], D2CSiteImageList.prototype, "headlineLine2", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => D2CSiteImageItem),
    __metadata("design:type", Array)
], D2CSiteImageList.prototype, "items", void 0);
